import OutcomeQuestionForm from "./OutcomeQuestionForm";

export default OutcomeQuestionForm;
